export class ProximityConstraint {
	constructor() {
	}
} 
